// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1665":"8c036dc6","2365":"724c28cc","4411":"01f8dc35","5051":"2f65ec62","5528":"724c28cc","6555":"724c28cc","9224":"ebeb479b","9765":"724c28cc"}[chunkId] + ".chunk.css";
};